"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.selectNextCell = function (focusedRow, focusedCell, options) {
    var newValues = {
        cell: focusedCell,
        row: focusedRow,
        changePage: false,
        pageChangeDir: 'next'
    };
    if (focusedCell >= options[focusedRow].length - 1) {
        newValues.cell = 0;
        if (focusedRow >= options.length - 1) {
            newValues.row = 0;
            newValues.changePage = true;
        }
        else {
            newValues.row = focusedRow + 1;
        }
    }
    else {
        newValues.cell = focusedCell + 1;
    }
    return newValues;
};
exports.selectPrevCell = function (focusedRow, focusedCell, options) {
    var newValues = {
        cell: focusedCell,
        row: focusedRow,
        changePage: false,
        pageChangeDir: 'prev'
    };
    if (focusedCell === 0) {
        var nextRow = (focusedRow || options.length) - 1;
        newValues.cell = options[nextRow].length - 1;
        newValues.row = nextRow;
        if (nextRow === options.length - 1) {
            newValues.changePage = true;
        }
    }
    else {
        newValues.cell = focusedCell - 1;
    }
    return newValues;
};
exports.selectNextRow = function (focusedRow, focusedCell, options) {
    var newValues = {
        cell: focusedCell,
        row: focusedRow,
        changePage: false,
        pageChangeDir: 'next'
    };
    var nextRow = focusedRow === options.length - 1 ? 0 : focusedRow + 1;
    newValues.cell = focusedCell > options[nextRow].length - 1 ? options[nextRow].length - 1 : focusedCell;
    newValues.row = nextRow;
    if (nextRow === 0) {
        newValues.changePage = true;
    }
    return newValues;
};
exports.selectPrevRow = function (focusedRow, focusedCell, options) {
    var newValues = {
        cell: focusedCell,
        row: focusedRow,
        changePage: false,
        pageChangeDir: 'prev'
    };
    var nextRow = focusedRow === 0 ? options.length - 1 : focusedRow - 1;
    newValues.cell = focusedCell > options.length - 1 ? options[nextRow].length - 1 : focusedCell;
    newValues.row = nextRow;
    if (nextRow === options.length - 1) {
        newValues.changePage = true;
    }
    return newValues;
};
exports.handleKeyboardNav = function (e, focusedRow, focusedCell, options) {
    var keyCode = e.keyCode;
    var dir = 'ltr';
    var htmlEl = document.querySelector('html');
    if (htmlEl && htmlEl.getAttribute('dir') === 'rtl') {
        dir = 'rtl';
    }
    var newValues = {
        cell: focusedCell,
        row: focusedRow,
        changePage: false,
        pageChangeDir: 'next'
    };
    if (keyCode === types_1.KeyCode.ArrowRight) {
        if (dir === 'ltr') {
            newValues = exports.selectNextCell(focusedRow, focusedCell, options);
        }
        else {
            newValues = exports.selectPrevCell(focusedRow, focusedCell, options);
        }
    }
    else if (keyCode === types_1.KeyCode.ArrowLeft) {
        if (dir === 'ltr') {
            newValues = exports.selectPrevCell(focusedRow, focusedCell, options);
        }
        else {
            newValues = exports.selectNextCell(focusedRow, focusedCell, options);
        }
    }
    else if (keyCode === types_1.KeyCode.ArrowUp) {
        newValues = exports.selectPrevRow(focusedRow, focusedCell, options);
    }
    else if (keyCode === types_1.KeyCode.ArrowDown) {
        newValues = exports.selectNextRow(focusedRow, focusedCell, options);
    }
    e.stopPropagation();
    e.preventDefault();
    return newValues;
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/date-picker/build/utils.js
// module id = 178
// module chunks = 0 1